module.exports = __webpack_public_path__ + "images/category_lp/watch/mainBg_be77aefaf4ccc0e41a7b06ef3ab9b0a5.jpg";